/**
 * Messages liés aux publications
 */

module.exports = {

    status: {
        draft: 'Brouillon',
        planned: 'Planifié',
        inProgress: 'En cours',
        paused: 'En pause',
        return: 'Retour agent',
        returnWaiting: 'Retour',
        validated: 'Validé',
        publicationWaiting: 'Publication programmée',
        publicationCanceled: 'Publication annulée',
        published: 'Publié',
        complaint: 'Réclamation',
        completed: 'Terminé',
        publishing: 'Publication en cours',
        aiSuggestion: 'Suggestion IA',
        customizing: 'Personnalisation',

        proposal: {
            accepted: 'Accepté',
            declined: 'Refusé',
            waiting: 'En attente',
            draft: 'Brouillon'
        },

        legend: {
            published: 'Post publié',
            scheduled: 'Post programmé',
            edited: 'Post en cours d\'édition',
            ideas: 'Idée de post'
        }
    },

    type: {
        image: 'Image',
        carousel: 'Carrousel',
        album: 'Album',
        video: 'Vidéo'
    },

    origin: {
        fromAi: 'IA',
        fromHorseChestnut: 'Marronnier',
        fromOrder: 'Sur mesure',
        fromCustomization: 'Perso'
    },

    priorityStatus: {
        normal: 'Normal',
        urgent: 'Urgent'
    },

    // Gestion des tâches d'un agent
    running: {
        button: {
            process: {
                continue: {
                    label: 'Continuer la tâche'
                },
                start: {
                    label: 'Commencer la tâche'
                }
            },
            customer: {
                details: {
                    altLabel: 'Consulter les détails du client { name }.'
                }
            }
        },
        list: {
            empty: 'Aucune tâche réalisée n\'a été trouvée.',
            fields: {
                publicId: 'ID',
                title: 'Nom',
                customer: 'Client',
                estimationTime: 'Durée',
                elapsedTime: 'Temps passé',
                networks: 'Réseaux',
                status: 'Statut'
            },
            networks: {
                options: {
                    default: 'Filtrer par réseau'
                }
            },
            statuses: {
                options: {
                    default: 'Filtrer par statut'
                }
            }
        },
        customer: {
            details: {
                modal: {
                    title: 'Fiche { customerName }',
                    menu: {
                        informations: {
                            label: 'Informations essentielles',
                        },
                        editorialLine: {
                            label: 'Ligne éditoriale et graphique'
                        },
                        notificationSettings: {
                            label: 'Communication'
                        }
                    }
                },
                sections: {
                    informations: {
                        fields: {
                            lastName: 'Nom',
                            firstName: 'Prénom',
                            email: 'Adresse email',
                            phone: 'Numéro de téléphone',
                            societyName: 'Nom de l\'établissement',
                            activitySector: 'Secteur d\'activité',
                            activitySummary: 'Résumé de l\'activité',
                            workforce: 'Nombre de personnes',
                            activityType: 'Type d\'activité',
                            siteUrl: 'Site internet'
                        }
                    },
                    editorialLine: {
                        fields: {
                            tone: 'Ton général de la ligne éditoriale',
                            formality: 'Tutoiement ou vouvoiement ?',
                            emoticonType: 'Avec ou sans emoji',
                            logo: 'Logo de la société',
                            graphicalCharter: 'Charte graphique'
                        }
                    },
                    notificationSettings: {
                        description: 'À quel moment le client souhaite être contacté par son CM au sujet de la création de ses publications ?',
                        fields: {
                            dayName: 'Jour de la semaine',
                            time: 'Horaire',
                            mediums: 'Par { mediums }',
                            frequency: 'Fréquence'
                        },
                        medium: {
                            email: 'email',
                            sms: 'SMS',
                            notification: 'notification mobile'
                        },
                        frequencies: {
                            weekly: 'Toutes les semaines',
                            fourteenDays: 'Toutes les deux semaines',
                            twentyOneDays: 'Toutes les trois semaines',
                            monthly: 'Une fois par mois'
                        },
                    }
                }
            }
        },
        processing: {
            task: {
                loading: {
                    error: 'Une erreur s\'est produite pendant le chargement de la tâche.'
                }
            },
            menu: {
                informations: {
                    label: 'Infos'
                },
                graph: {
                    label: 'Graphisme'
                },
                hook: {
                    label: 'Accroche',
                },
                history: {
                    label: 'Historique'
                }
            },
            briefing: {
                logo: {
                    with: 'Logo présent',
                    without: 'Logo non présent',
                    consult: {
                        altLabel: 'Consulter le logo.',
                    },
                    download: {
                        altLabel: 'Télécharger le logo.'
                    }
                },
                canvaUrl: 'Projet Canva',
                fromHorseChestnut: 'Marronnier',
                fields: {
                    type: 'Type de tâche',
                    networks: 'Canal | Canal | Canaux',
                    format: 'Format',
                    categories: 'Thématique | Thématique | Thématiques',
                    /***/
                    subject: 'Sujet',
                    target: 'Cible',
                    marketing: 'Objectif marketing',
                    tone: 'Tonalité',
                    emoticonType: 'Avec ou sans emoji',
                    keywords: 'Mot-clé | Mot-clé | Mots-clés'
                },
                informations: {
                    charter: {
                        logo: {
                            label: 'Logo',
                            without: 'Pas de logo'
                        },
                        charter: {
                            label: 'Charte graphique',
                            without: 'Aucune charte graphique'
                        }
                    },
                    details: {
                        product: {
                            fields: {
                                why: 'À quel problématique répond le produit / service',
                                name: 'Nom du produit / service',
                                profit: 'Bénéfices du produit / service'
                            }
                        },
                        actuality: {
                            fields: {
                                about: 'De quoi traite l\'actualité',
                                title: 'Titre de l\'actualité',
                                date: 'Date',
                                relation: 'Relation avec l\'activité du client'
                            }
                        },
                        event: {
                            fields: {
                                name: 'Nom de l\'événement',
                                location: 'Lieu',
                                date: 'Date',
                                description: 'Description',
                                speakers: 'Intervenants'
                            }
                        },
                        recruitment: {
                            fields: {
                                name: 'Nom du poste',
                                type: 'Type de poste',
                                missions: 'Missions',
                                profile: 'Profil recherché',
                                salary: 'Tranche de salaire',
                                location: 'Lieu',
                                date: 'À partir de quand ?',
                                email: 'Contact email pour candidatures'
                            }
                        },
                        brand: {
                            fields: {
                                name: 'Nom de la marque',
                                sector: 'Secteur',
                                message: 'Message que le client souhaite diffuser',
                                inHook: 'Souhaitez-vous qu\'elle figure dans l\'accroche ?'
                            }
                        },
                        aiSubject: {
                            fields: {
                                subject: 'Sujet'
                            }
                        },
                        other: {
                            fields: {
                                message: 'Message',
                            }
                        },
                        standard: {
                            fields: {
                                message: 'Message'
                            }
                        },
                        fields: {
                            publicationUrl: 'URL de redirection',
                            inHook: 'Figure'
                        }
                    }
                },
                graph: {
                    briefing: 'Exigences graphiques',
                    text: 'Idée graphique',
                    files: 'Éléments graphiques',
                    wishedVideo: 'Modèle de vidéo souhaité',
                    canva: {
                        title: 'Projet Canva',
                        button: {
                            label: 'Consulter le projet Canva'
                        }
                    }
                },
            },
            pause: {
                modal: {
                    title: 'Mettre en pause',
                    description: 'Vous souhaitez mettre en pause la tâche en cours ? Merci de justifier la mise en pause auprès de votre manager.',
                    form: {
                        error: 'Une erreur s\'est produite pendant la mise en pause de la tâche.',
                        fields: {
                            reason: 'Justification de la mise en pause'
                        }
                    }
                }
            },
            countDown: {
                end: 'Le temps de réalisation de la tâche est écoulé.'
            },
            history: {
                menu: {
                    customer: {
                        label: 'Historique du client'
                    },
                    task: {
                        label: 'Historique de la publication'
                    }
                },
                customer: {
                    loading: {
                        error: 'Une erreur s\'est produite pendant le chargement de l\'historique du client.'
                    },
                    empty: 'L\'historique du client est vide.'
                },
                task: {
                    loading: {
                        error: 'Une erreur s\'est produite pendant le chargement de l\'historique de la tâche.'
                    },
                    version: 'Version { version }',
                    empty: 'L\'historique de résolution de la tâche est vide.'
                },
                details: {
                    hook: {
                        title: 'Accroche'
                    },
                    visual: {
                        suggestedMedias: {
                            button: {
                                display: 'Afficher les fichiers proposés par l\'IA',
                                hide: 'Cacher les fichiers proposés par l\'IA'
                            }
                        }
                    }
                }
            },
            proposal: {
                form: {
                    error: 'Une erreur s\'est produite pendant l\'enregistrement de votre proposition.',
                    fields: {
                        hook: 'Accroche',
                        agentComment: 'Commentaire { applicationName }',
                        visualGenericComment: 'Commentaire sur le visuel à créer'
                    },
                    addFile: {
                       button: {
                           label: 'Ajouter un fichier'
                       }
                    },
                    customer: {
                        comment: {
                            label: 'Commentaire du client'
                        }
                    }
                }
            },
            hookSuggestions: {
                suggestion: {
                    title: 'Proposition GPT { position }',
                    button: {
                        select: 'Utiliser'
                    }
                }
            }
        }
    },

    // Gestion de la notation
    rating: {
        modal: {
            title: 'Nous sommes impatients de voir les résultats !',
            description: 'Bravo, votre publication est prête pour être diffusée le { date } sur { networks } !',
            ratingTitle: 'Votre avis',
            ratingDescription: 'Dites-nous ce que vous avez pensé du travail de votre Community Manager !'
        }
    },

    // Gestion d'un retour
    return: {
        preview: {
            date: 'Date',
            hook: 'Accroche'
        },
        modal: {
            title: '{ taskTitle } - Effectuer un retour'
        },
        form: {
            error: 'Une erreur s\'est produite pendant l\'enregistrement de votre retour. Veuillez vérifier que vous avez rempli correctement le formulaire.',
            fieldsets: {
                hook: 'Accroche',
                visual: 'Visuel'
            },
            creditsRequired: '{ count } crédit est nécessaire | { count } crédit est nécessaire | { count } crédits sont nécessaires',
            creditsAnchor: '<a href="{ url }" title="">Acquérir des crédits</a>',
            hook: {
                fields: {
                    comment: {
                        withoutCredits: {
                            label: 'Décrivez-nous les retours souhaités. À noter qu’il ne peut être demandé la réécriture complète de l\'accroche.'
                        },
                        withCredits: {
                            label: 'Vous avez la possibilité de demander un autre retour en utilisant vos crédits ({ credits } crédits).'
                        }
                    }
                },
                buttons: {
                    selfModify: 'Je modifie moi-même',
                    requestReturn: 'Je demande un retour',
                    reset: 'Rétablir l\'accroche'
                }
            },
            files: {
                menu: {
                    button: 'Fichier { index }'
                },
                fields: {
                    genericComment: 'Indiquez-nous le visuel à créer',
                    agree: {
                        true: 'J\'adore',
                        false: 'J\'aime bien, mais...'
                    },
                    comment: {
                        withoutCredits: {
                            label: 'Décrivez-nous les retours souhaités. À noter qu’il ne peut être demandé la refonte totale du visuel.'
                        },
                        withCredits: {
                            label: 'Vous avez la possibilité de demander un autre retour en utilisant vos crédits ({ credits } crédits).'
                        }
                    }
                },
                descriptions: {
                    genericComment: 'Demandez la création d\'un visuel sur mesure en utilisant vos crédits.'
                },
                upload: {
                    legal: 'En ajoutant un nouveau fichier, vous déclarez avoir les droits sur celui-ci et ne pas tenir { application } responsable en cas de conflit.',
                    button: {
                        label: 'Aucun fichier à télécharger | Télécharger le visuel | Télécharger les visuels'
                    }
                }
            },
            fields: {
                publicationDate: 'Date de diffusion envisagée',
                publishNow: 'Publier maintenant',
                agentComment: 'Commentaire { applicationName }'
            },
            submit: {
                validate: {
                    label: 'Valider le retour'
                }
            }
        }
    },

    targeting: {
        genders: {
            female: 'Féminin',
            male: 'Masculin'
        },
        location: {
            type: {
                digital: 'Distanciel',
                presence: 'Présentiel',
                hybrid: 'Distanciel et présentiel'
            }
        }
    },

    graph: {
        type: {
            photo: 'Un style photo',
            illustrated: 'Un style illustré',
            textual: 'Un style textuel',
            agentChoice: 'Je fais confiance'
        }
    },

    marketingObjective: {
        visibility: 'Visibilité',
        traffic: 'Trafic',
        engagement: 'Engagement'
    },

    types: {
        complete: {
            label: 'Visuel + Accroche',
        },
        visual: {
            label: 'Visuel'
        },
        hook: {
            label: 'Accroche'
        }
    },

    subject: {
        types: {
            product: 'Un produit / service',
            actuality: 'Une actualité',
            event: 'Un évènement',
            recruitment: 'Un recrutement',
            brand: 'Une marque',
            other: 'Autre'
        },
    },

    brand: {
        sectors: {
            team: 'Équipe',
            value: 'Valeur',
            csr: 'RSE',
            international: 'International',
            employer: 'Marque employeur',
            label: 'Label - certification',
            history: 'Histoire',
            other: 'Autre'
        }
    },


    // Rédaction d'une publication
    write: {
        loading: {
            taskConfiguration: {
                error: 'Une erreur s\'est produite pendant le chargement de la configuration.'
            },
            taskConfigurationGroup: {
                error: 'Une erreur s\'est produite pendant le chargement de la configuration.'
            },
            taskFormats: {
                error: 'Une erreur s\'est produite pendant le chargement des formats.'
            },
            publicationCategories: {
                error: 'Une erreur s\'est produite pendant le chargement des catégories.'
            },
            globalConfiguration: {
                error: 'Une erreur s\'est produite pendant le chargement de la configuration.'
            },
            draftTasks: {
                error: 'Une erreur s\'est produite pendant le chargement des brouillons.'
            }
        },
        draft: {
            modal: {
                title: 'Brouillon | Brouillon | Brouillons',
                description: 'Aucun brouillon n\'existe. | Un brouillon existe : | { count } brouillons existent :',
                buttons: {
                    create: {
                        label: 'Créer une nouvelle publication'
                    }
                },
                tasks: {
                    title: {
                        default: 'Brouillon { position }'
                    }
                }
            }
        },
        planned: {
            success: 'La tâche { taskTitle } a été planifiée avec succès pour le { date } à { time }.'
        },
        error: 'Une erreur s\'est produite pendant l\'enregistrement.',
        step: {
            idea: 'L\'idée',
            text: 'Le brief textuel',
            graph: 'Le brief graphique',
            informations: 'Infos et délais'
        },
        deliveryProjection: {
            networks: {
                label: 'Réseau : | Réseau : | Réseaux :',
                empty: 'À sélectionner'
            },
            delivery: {
                label: 'Livraison :',
                button: {
                    urgent: {
                        label: 'Plus vite'
                    },
                    normal: {
                        label: 'Plus tard'
                    }
                }
            },
            category: {
                label: 'Sujet'
            },
            publicationSuggestion: {
                label: 'Suggestion'
            },
            videoSelected: {
                label: 'Vidéo'
            }
        },
        idea: {
            introduction: {
                title: 'Avez-vous une idée ?',
                description: 'Décrivez le post de votre rêve à travers notre formulaire ou consultez une galerie d\'idées de pots pour vous inspirer !',
                withIdea: {
                    label: 'Oui, j\'ai une idée de post'
                },
                withoutIdea: {
                    label: 'Inspirez-moi !'
                }
            },
            publicationSuggestions: {
                title: 'Vous n’avez pas d\'idées ?',
                description: 'Sélectionnez un visuel qui vous inspire et demandez des modifications pour l\'adapter à votre besoin/idée.',
                empty: 'Aucune suggestion ne correspond à votre recherche.',
                loadingError: 'Une erreur s\'est produite pendant le chargement des suggestions.',
                filterForm: {
                    fields: {
                        thematic: 'Thématique',
                        networks: 'Réseaux',
                        format: 'Format',
                        marketingObjective: 'Objectif',
                    },
                    currentFilters: {
                        label: 'Filtres actifs'
                    }
                },
                item: {
                    details: {
                        button: {
                            label: 'Plus de détails'
                        },
                        modal: {
                            title: '{ title } - Aperçu',
                            select: {
                                error: 'Une erreur s\'est produite pendant l\'enregistrement de votre choix.',
                                button: {
                                    label: 'Sélectionner cette publication'
                                }
                            }
                        },
                        description: {
                            title: 'Détails de la publication'
                        },
                        hook: {
                            title: 'Accroche'
                        }
                    }
                }
            },
            taskType: {
                title: 'Type de publication',
                description: 'Choisissez une publication complète (visuel/vidéo + accroche) ou bien seulement la création d\'un visuel ou d\'une accroche.'
            },
            networks: {
                title: 'Choix des canaux',
                description: 'Sélectionnez le ou les réseaux ainsi que la page sur lesquelles vous souhaitez que le post soit publié.',
                enabled: {
                    error: 'Une erreur s\'est produite pendant l\'activation du réseau { network }.'
                },
                disabled: {
                    error: 'Une erreur s\'est produite pendant la désactivation du réseau { network }.'
                },
                accounts: {
                    about: 'Sélectionner la ou les pages de diffusion :',
                    loading: {
                        error: 'Une erreur s\'est produite pendant le chargement de vos comptes { network }.'
                    }
                }
            },
            formats: {
                title: 'Format',
                description: 'Choisissez votre format de post. En fonction du format sélectionné, le nombre de crédits peut varier par rapport à la demande initiale.',
                incompatible: 'Format non disponible sur les réseaux sélectionnés'
            },
            hookSetting: {
                title: 'Accroche',
                fields: {
                    common: 'Une seule accroche',
                    unique: 'Une accroche par réseau'
                }
            }
        },
        about: {
            title: 'De quoi je veux parler ?',
            description: 'Choisissez la principale thématique de votre sujet. Vous pouvez aussi créer votre thématique en cliquant sur le "bouton +"',
            forms: {
                details: {
                    fields: {
                        languages: 'Langues de la publication'
                    },
                    product: {
                        fields: {
                            why: 'À quel problématique répond le produit / service',
                            name: 'Nom du produit / service',
                            profit: 'Citez deux bénéfices du produit / service',
                            url: 'URL de redirection',
                            inHook: 'Souhaitez-vous qu\'elle figure dans l\'accroche ?'
                        }
                    },
                    actuality: {
                        fields: {
                            about: 'De quoi traite l\'actualité',
                            title: 'Titre de l\'actualité',
                            date: 'Date',
                            relation: 'Exprimez la relation avec votre activité',
                            url: 'URL de redirection',
                            inHook: 'Souhaitez-vous qu\'elle figure dans l\'accroche ?'
                        }
                    },
                    recruitment: {
                        fields: {
                            name: 'Nom du poste',
                            type: 'Type de poste',
                            missions: 'Missions',
                            profile: 'Profil recherché',
                            salary: 'Tranche de salaire',
                            location: 'Lieu',
                            date: 'À partir de quand ?',
                            email: 'Contact email pour candidatures',
                            url: 'URL de redirection',
                            inHook: 'Souhaitez-vous qu\'elle figure dans l\'accroche ?'
                        }
                    },
                    event: {
                        fields: {
                            name: 'Nom de l\'événement',
                            location: {
                                digital: 'Lien pour participer à l\'événement',
                                presence: 'Lieu où se tiendra l\'événement',
                                hybrid: 'Lieu où se tiendra l\'événement'
                            },
                            locationType: 'Type d\'événement',
                            date: 'Date',
                            time: 'Horaire',
                            timezone: 'Fuseau horaire',
                            description: 'Description',
                            speakers: 'Intervenants',
                            url: 'URL de redirection',
                            inHook: 'Souhaitez-vous qu\'elle figure dans l\'accroche ?'
                        },
                        location: {
                            description: {
                                digital: 'Indiquer l\'adresse où les utilisateurs peuvent se connecter pour participer à l\'événement.',
                                presence: 'Indiquer l\'adresse où se rendre pour participer à l\'événement.',
                                hybrid: 'Indiquer l\'adresse physique et numérique où se rendre pour participer à l\'événement.'
                            }
                        }
                    },
                    brand: {
                        fields: {
                            name: 'Nom de la marque',
                            sector: 'Catégorie',
                            sectorPrecision: 'Autre secteur',
                            message: 'Décrivez le message que vous souhaitez diffuser',
                            url: 'URL de redirection',
                            inHook: 'Souhaitez-vous qu\'elle figure dans l\'accroche ?'
                        }
                    },
                    other: {
                        fields: {
                            message: 'Dites-nous tout',
                            url: 'URL de redirection',
                            inHook: 'Souhaitez-vous qu\'elle figure dans l\'accroche ?'
                        }
                    },
                    standard: {
                        fields: {
                            taskTitle: 'Titre de la publication',
                            message: 'Contexte général (de quoi je souhaite parler ?)',
                            url: 'URL de redirection',
                        },
                        button: {
                            publicationUrl: {
                                test: {
                                    label: 'Tester l\'adresse'
                                }
                            }
                        }
                    }
                }
            },
            category: {
                error: 'Une erreur s\'est produite pendant l\'ajout de la catégorie.'
            }
        },
        targeting: {
            title: 'Ciblage',
            description: 'Détaillez les caractéristiques des personnes qui doivent lire votre future publication.',
            form: {
                fields: {
                    description: 'À qui s\'adresse le contenu ?',
                    gender: 'Genre',
                    age: 'Âge',
                    location: 'Rayonnement de ma prise de parole'
                },
                genders: {
                    undefined: 'Tous',
                    female: 'Féminin',
                    male: 'Masculin'
                },
                ages: {
                    none: 'Pas de restriction'
                }
            }
        },
        marketingObjective: {
            title: 'Objectifs marketing',
            description: 'Sélectionnez l\'objectif le plus proche du résultat attendu.',
            buttons: {
                visibility: {
                    description: 'Je souhaite délivrer une information à ma communauté'
                },
                traffic: {
                    description: 'Je souhaite inciter ma communauté à visiter mon site web'
                },
                engagement: {
                    description: 'Je souhaite faire interagir ma communauté : commentaires, likes, partages,...'
                }
            }
        },
        tone: {
            title: 'Tonalité',
            description: 'Pour cette publication, je suis plutôt...',
            form: {
                fields: {
                    editorialLine: 'Tonalité de la publication',
                    emoticon: 'Avec ou sans émoji ?'
                }
            }
        },
        keywords: {
            title: 'Mots-clés',
            description: 'Indiquez les mots-clés qui caractérisent le plus votre publication et qui devront apparaitre dans l\'accroche.',
            form: {
                fields: {
                    keyword: 'Saisir des mots-clés'
                },
                remaining: '0 restant | 1 restant | { count } restants.'
            },
            keyword: {
                description: 'Presser la touche ENTREE de votre clavier pour ajouter un mot clé.'
            }
        },
        graph: {
            type: {
                title: 'Je souhaite',
                description: 'Donnez une orientation graphique du type de visuel que vous souhaitez pour cette publication.'
            },
            videoSuggestions: {
                title: 'Je souhaite',
                description: 'Choisissez le modèle vidéo de votre choix en cliquant sur "Plus de détails" puis sélectionnez la vidéo.',
                loadingError: 'Une erreur s\'est produite pendant le chargement des suggestions.',
                selectError: 'Une erreur s\'est produite pendant l\'enregistrement de votre choix.',
                suggestions: {
                    empty: 'Aucune suggestion ne correspond aux paramètres de votre tâche.',
                    credits: '{ credits } crédits',
                    moreInformationsButton: {
                        label: 'Plus de détails'
                    },
                    selectVideoButton: {
                        label: 'Sélectionner cette vidéo'
                    }
                }
            },
            settings: {
                title: 'Mon logo doit-il figurer sur ma publication ?', /*'Charte graphique',*/
                /*settings: {
                    logo: {
                        title: 'Mon logo doit-il figurer sur ma publication ?'
                    },
                    charter: {
                        title: 'Ma charte graphique doit apparaître sur ma publication ?'
                    }
                },**/
                description: 'Tout est dans le titre ;-)',
                charter: {
                    required: 'Vous devez compléter votre charte graphique pour continuer. Vous pouvez le faire en cliquant sur ce bouton.',
                    button: {
                        label: 'Compléter la charte graphique'
                    },
                    modal: {
                        title: 'Charte graphique'
                    }
                }
            },
            contents: {
                title: 'Des exigences graphiques ?',
                description: 'Aidez notre graphiste à s\'approcher le plus possible du rendu que vous souhaitez.',
                form: {
                    fields: {
                        wishedVisualBriefing: 'Exigences graphiques',
                        wishedVisualText: 'Je veux du texte sur mon visuel'
                    },
                    placeholders: {
                        wishedVisualBriefing: 'Une couleur dominante, une forme illustrée, une typographie'
                    }
                },
                suggestion: {
                    preview: {
                        title: 'Visuel | Visuel | Visuels'
                    }
                }
            },
            upload: {
                title: {
                    default: 'Éléments qui doivent figurer',
                    hook: 'Vos visuels'
                },
                description: {
                    default: 'Je transmets les éléments indispensables qui doivent figurer sur le visuel (photo produit, équipe, salon, affiche, event, etc.).',
                    hook: 'Avez-vous des visuels à nous transmettre ?'
                },
                form: {
                    fields: {
                        legalAccepted: 'J\'ai les droits d\'utilisation de ces fichiers.',
                    },
                    legalAccepted: {
                        description: 'En cochant cette case, vous déclarez avoir les droits sur ces fichiers et ne pas tenir { application } responsable en cas de conflit.'
                    },
                    button: {
                        addFile: {
                            label: 'Ajouter un fichier'
                        }
                    }
                }
            }
        },
        informations: {
            summary: {
                title: 'Récapitulatif',
                fields: {
                    taskType: 'Type :',
                    networks: 'Réseau : | Réseau : | Réseaux :',
                    format: 'Format :',
                    category: 'Thématique :',
                    subject: 'Sujet :',
                    objective: 'Objectif :',
                    styleWished: 'Style :',
                    withLogo: 'Logo :',
                    withCharter: 'Charte graphique :',
                    remainingCredits: '(0 restant) | ({ count } restant) | ({ count } restants)'
                }
            },
            delivery: {
                impossible: 'Aucune date de livraison n\'a été trouvée.',
                form: {
                    title: 'Infos et délais',
                    description: 'Nous vous proposons par défaut un délai de livraison de votre publication. Utilisez le mode "Urgent" si vous êtes pressé !',
                    fields: {
                        propositions: 'Délai de livraison proposé',
                        title: 'Donnez un titre à votre publication',
                        wishedDate: 'Date de diffusion envisagée'
                    },
                    withoutCredits: 'Gratuit'
                }
            }
        }
    },

    list: {
        loadingResourcesError: 'Une erreur s\'est produite pendant le chargement des données.',
        month: {
            navigation: {
                lightMenu: {
                    title: 'Vos posts'
                }
            },
            loadError: 'Une erreur s\'est produite pendant le chargement des données.',
            empty: {
                noIdea: 'Aucune idée de post pour { currentMonth } n\'a encore été générée.',
                canGenerate: 'Cliquez sur "Générer de nouvelles idées" !',
                generating: 'Les premières idées de posts vont apparaitre dans quelques instants. Veuillez patienter pendant la génération du 1er post.'
            },

            networks: {
                label: 'Filtrer :'
            },
            generate: {
                newIdeas: {
                    button: 'Générer de nouvelles idées'
                },

                convertSubjectInTaskIdea: {
                    button: 'Convertir en idée de post'
                },

                initialized: 'Pour voir apparaitre vos posts, cliquez sur le bouton "Valider mes sujets". Vos premières publications apparaitront ici après la validation des sujets 🤗',
                button: {
                    label: 'Générer mon planning'
                },
                subscriptionRequired: {
                    message: 'Vous devez être abonné pour générer un nouveau planning.',
                    button: {
                        subscribe: {
                            label: 'Je m\'abonne'
                        }
                    }
                }
            },
            completeGeneration: {
                button: {
                    label: 'Générer la suite du planning'
                }
            },
            validationSubjects: {
                ready: 'Vos sujets sont prêts à être validés. Cliquez sur le bouton "Valider mes sujets".',
                button: {
                    label: 'Valider mes sujets'
                }
            },
            searching: {
                placeholder: 'Effectuer une recherche...',
                date: 'Date'
            },
            suggestions: {
                item: {
                    title: 'Post { position }',
                    description: {
                        title: 'Description',
                        updateError: 'Une erreur s\'est produite pendant la mise à jour de la description.'
                    },
                    date: '{ date } à { hour }H{ minute }',
                    fromHorseChestnut: 'Marronnier',
                    horseChestnutEvent: {
                        versions: {
                            navigation: {
                                title: 'Il n\'existe pas d\'autre version pour cette journée | Il existe une autre version pour cette journée | Il existe d\'autres versions pour cette journée'
                            }
                        }
                    },

                    tutorialTask: {
                        title: 'Titre du post'
                    },

                    header: {
                        fields: {
                            title: 'Titre du post'
                        },
                        validateButton: {
                            label: 'Publier le post',
                            help: {
                                tooltip: 'Valider pour programmer le post sur vos réseaux sociaux',
                                close: {
                                    label: 'J\'ai compris, ne plus afficher'
                                }
                            }
                        },
                        aiSubject: {
                            source: 'Source'
                        }
                    },
                    regenerateAISuggestionButton: {
                        altLabel: 'Générer un nouveau post (image + accroche)'
                    },
                    hook: {
                        title: 'Accroche',
                        alternativeHooks: {
                            title: 'Accroche validée : Alternative { position }',
                            menu: {
                                item: {
                                    label: 'Alternative { position }'
                                }
                            }
                        },
                        regenerate: {
                            button: {
                                altTitle: 'Générer une nouvelle accroche'
                            },
                            modal: {
                                title: 'Générer l\'accroche via l\'IA'
                            }
                        }
                    },
                    convertInReturn: {
                        button: {
                            label: 'Demander un retour'
                        }
                    },
                    medias: {
                        title: 'Visuel',
                        description: 'Validez le visuel de votre choix',
                        preview: {
                            button: {
                                altLabel: 'Prévisualiser le visuel { position }.'
                            },
                            modal: {
                                title: 'Prévisualiser le visuel { position }'
                            }
                        },
                        valid: {
                            button: {
                                altLabel: 'Valider le visuel'
                            }
                        },
                        uploadMediaForm: {
                            error: 'Une erreur s\'est produite pendant l\'enregistrement.',
                            errorTooLarge: 'Votre fichier dépasse la taille maximum de 50 Mo.',
                            fields: {
                                file: 'Uploader mon visuel / vidéo'
                            },
                            legal: {
                                description: 'En ajoutant un nouveau fichier, vous déclarez avoir les droits sur celui-ci et ne pas tenir { application } responsable en cas de conflit.'
                            }
                        },
                        regenerate: {
                            button: {
                                altTitle: 'Générer de nouvelles images'
                            },
                            modal: {
                                title: 'Générer d\'autres images via l\'IA'
                            }
                        },
                        remove: {
                            modal: {
                                message: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
                                error: 'Une erreur s\'est produite pendant la suppression du fichier.'
                            }
                        },
                        generatedByIA: {
                            altLabel: 'Image générée par IA'
                        },
                        graphicalLineTemplate: {
                            slideshow: {
                                title: 'Modèle graphique',
                                template: {
                                    generating: 'La génération en cours peut prendre quelques secondes, le temps de générer les images et les textes.'
                                }
                            },
                            add: {
                                altLabel: 'Créer un template'
                            },
                            edit: {
                                altLabel: 'Éditer l\'image'
                            },
                            preview: {
                                toolbar: {
                                    openEditorButton: {
                                        label: 'Edition avancée'
                                    }
                                }
                            }
                        },
                        select: {
                            title: 'Image de fond'
                        }
                    },
                    footer: {
                        informations: {
                            fields: {
                                format: 'Format',
                                status: 'Statut',
                                subject: 'Sujet',
                                marketingObjective: 'Objectif',
                                networks: 'Réseau',
                                tone: 'Ton',
                                emoticonType: 'Emojis',
                                keywords: 'Mots clés'
                            }
                        },
                        buttons: {
                            editMarketingObjective: {
                                label: 'Modifier l\'objectif marketing'
                            },
                            addKeyword: {
                                label: 'Ajouter un mot clé'
                            }
                        }
                    }
                }
            },
            requestReturn: {
                button: {
                    label: 'Demander un retour'
                }
            },
            requestMediaReturn: {
                button: {
                    label: 'Demander un visuel'
                }
            },
            planningPresentation: {
                introduction: {
                    withTasks: 'Votre premier post est prêt à l\'emploi, cliquez sur "GO" pour<br />Démarrer l\'aventure Tookano !',
                    withoutTasks: 'Vos publications sont cours de génération. Cela peut prendre quelques minutes.'
                },
                button: {
                    start: 'GO'
                },
                videoModal: {
                    button: {
                        close: {
                            label: 'Passer la vidéo'
                        }
                    }
                },
                detailModal: {
                    line1: 'Votre premier post créé à partir des informations que vous avez renseignées.',
                    line2: 'Vous pouvez aussi accéder à votre interface de gestion de votre Ligne Editoriale pour renseigner ou modifier vos paramètres (couleurs, préférences, style, etc...).',
                    button: {
                        close: {
                            label: 'Je veux la suite !'
                        }
                    }
                }
            }
        },
        table: {
            fields: {
                title: 'Objet',
                agent: 'Agent',
                priorityStatus: 'Statut',
                status: 'État',
                publicationDate: 'Date publi.',
                networks: 'Réseaux'
            }
        },
        item: {
            defaultTitle: 'Tâche sans titre',
            date: {
                planned: 'Date de livraison estimée :',
                publicationWaiting: 'Publication prévue le',
                published: 'Publié le'
            }
        },
        button: {
            periodicity: {
                weekly: {
                    label: 'S',
                    altLabel: 'Afficher la vue hebdomadaire.'
                },
                monthly: {
                    label: 'M',
                    altLabel: 'Afficher la vue mensuelle.'
                }
            },
            add: {
                label: 'Ajouter un post',
                altLabel: 'Ajouter une publication.'
            },
            edit: {
                altLabel: 'Éditer la tâche { task }.'
            },
            aiSettings: {
                label: 'Paramètres IA',
                altLabel: 'Éditer les paramètres de la gestion des plannings des publications.'
            },
            aiWritingStyle: {
                altLabel: 'Éditer les paramètres du style d\'écriture.'
            },
            duplicate: {
                withTitle: 'Dupliquer la tâche { task }.',
                withoutTitle: 'Dupliquer cette tâche.',
                label: 'Dupliquer'
            },
            consultPublicationProposals: {
                altLabel: 'Consulter les propositions de publication de la tâche { task }.'
            },
            return: {
                label: 'Retour',
                altLabel: 'Effectuer un retour ou valider la tâche { task }.'
            },
            mode: {
                month: {
                    label: 'Liste',
                    altLabel: 'Afficher sous forme de liste.'
                },
                calendar: {
                    label: 'Calendrier',
                    altLabel: 'Afficher sous forme de calendrier.'
                }
            },
            returnToList: {
                label: 'Retour vers la liste'
            },
            filters: {
                label: 'Filtrer'
            },
            startTutorial: {
                altLabel: 'Accéder au tutoriel'
            },
            changeOwnerVisibility: {
                isVisible: {
                    altLabel: 'Cacher la publication au client.',
                },
                isHide: {
                    altLabel: 'Montrer la publication au client.'
                }
            }
        },
        filters: {
            fields: {
                searching: 'Rechercher une publication',
                status: 'État',
                priorityStatus: 'Statut',
                network: 'Réseau',
                publicationDate: 'Publiée le',
                ideas: 'Idées de posts',
                edited: 'En cours d\'édition',
                scheduled: 'Posts programmés',
                subjectsIdeas: 'Veille',
                published: 'Posts publiés',
                pendingValidation: 'Vérification',
            },
        }
    },

    // Gestion par un manager
    managing: {

        list: {
            fields: {
                publicId: 'ID',
                title: 'Nom',
                customer: 'Client',
                agent: 'Agent',
                estimatedTime: 'Durée',
                elapsedTime: 'Temps passé',
                priorityStatus: 'Statut',
                status: 'État',
                networks: 'Réseaux'
            },
            remaining: {
                title: 'Tâches à réaliser'
            },
            completed: {
                title: 'Historique des tâches'
            }
        },

        item: {
            transfert: {
                anotherAgentButton: {
                    altLabel: 'Transférer la tâche { task } à un autre agent.'
                },
                anotherAgentModal: {
                    title: 'Transférer la tâche { task } à un autre agent'
                }
            }
        }
    },

    comment: {
        postedAt: 'Le { date }',
        author: {
            default: 'Utilisateur { network }'
        },
        validationRequested: {
            from: 'Vous avez demandé à { to } de valider la tâche.',
            to: 'Une demande de validation vous a été demandée.'
        },
        validationAccepted: {
            from: {
                yes: 'Vous avez validé la réalisation.',
                no: 'Vous avez refusé la réalisation.'
            },
            to: {
                yes: '{ to } a accepté la réalisation.',
                no: '{ to } a refusé la réalisation'
            }
        }
    },

    // Boost, gestion d'une publicité
    advert: {
        boostButton: {
            facebook: {
                label: 'Booster l\'audience sur Facebook ou Instagram'
            }
        }
    },

    validation: {
        status: {
            waiting: 'En attente de validation',
            declined: 'En attente de modification',
            accepted: 'Validé',
            disabled: 'Désactivé',
            completed: 'Terminé',
            new: 'Nouveau retour'
        },
        statusDateLabel: {
            read: 'Retour lu',
            sent: 'Retour envoyé',
            new: 'Nouveau retour'
        },
        button: {
            request: {
                label: 'Faire vérifier le post'
            }
        },
        request: {
            modal: {
                title: 'Faire vérifier le post',
                emptyRecipients: 'Nous n\'avons pas pu déterminer de destinataire pour cette demande.'
            },
            form: {
                error: 'Une erreur s\'est produite pendant l\'envoi de votre demande.',
                selectContact: 'Sélectionner le profil qui devra valider la publication.'
            }
        },
        requestSent: {
            modal: {
                message: 'Mail envoyé !',
                button: {
                    close: {
                        label: 'Terminé'
                    }
                }
            }
        },
        waitingList: {
            button: {
                accept: {
                    label: 'Accepter',
                    altLabel: 'Accepter la demande de validation.',
                    error: 'Une erreur s\'est produite pendant l\'acceptation de la demande.',
                    success: 'Merci d\'avoir validé le post !'
                },
                decline: {
                    label: 'Refuser',
                    altLabel: 'Refuser la demande de validation.',
                    error: 'Une erreur s\'est produite pendant le refus de la demande.'
                }
            },
            modal: {
                onAccept: {
                    message: 'Merci d\'avoir validé le post !',
                    button: {
                        close: {
                            label: 'Terminé'
                        }
                    }
                }
            }
        }
    }

};
